import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {CircularProgress} from '@mui/material';
import {ExportStep} from './export.jsx';
import {Modal} from '../components/modal.js';
import {ReviewChangeStep} from './ReviewChange/index.jsx';
import {ReviewStep} from './ReviewObjects.jsx';
import {ThemeProvider} from '../theme-provider.jsx';
import {fetchSeriesInfo} from '../api.js';
import {getVisualizationSeries} from '../util/map.js';
import {useQuery} from '@tanstack/react-query';

const STEPS = {
  REVIEW: 0,
  EXPORT: 1,
};

export const ReviewDetections = ({
  open,
  onClose,
  changeDetection,
  detections,
  layer,
  feed,
}) => {
  const [step, setStep] = useState(STEPS.REVIEW);
  const [exportFeatures, setExportFeatures] = useState([]);
  const {data: seriesInfo, isLoading: loading} = useQuery({
    queryKey: ['series', getVisualizationSeries(feed)],
    queryFn: () => fetchSeriesInfo(getVisualizationSeries(feed)),
    enabled: changeDetection,
  });

  const Review = changeDetection === true ? ReviewChangeStep : ReviewStep;

  return (
    <ThemeProvider dark>
      <Modal open={open}>
        {loading && <CircularProgress />}
        {!loading && step === STEPS.REVIEW && (
          <Review
            detections={detections}
            layer={layer}
            feed={feed}
            onExport={detects => {
              setExportFeatures(detects);
              setStep(STEPS.EXPORT);
            }}
            seriesInfo={seriesInfo}
            onClose={() => onClose()}
          />
        )}
        {!loading && step === STEPS.EXPORT && (
          <ExportStep
            features={exportFeatures}
            onBack={() => setStep(STEPS.REVIEW)}
            onClose={() => onClose()}
          />
        )}
      </Modal>
    </ThemeProvider>
  );
};

ReviewDetections.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  detections: PropTypes.array,
  layer: PropTypes.string,
  changeDetection: PropTypes.bool,
  feed: PropTypes.object,
};
